import React, { useMemo, useState } from "react";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import makeAnimated from "react-select/animated";
import { regions } from "../../data/country";
// import { colourOptions } from '../data';
import styles from './AmlPoliticallyExposed.module.css'

import {
    Block,
    Input,
    Button,
    DocumentScan,
    Loading,
    PreviewAltCard,
    Icon,
    PreviewCard,
    // Select,
} from "../../../components/Component";
import { useForm } from "react-hook-form";
import RSelect2 from "../../../components/select/ReactSelect2";
import countryList from "react-select-country-list";
import { apiRequest } from "../../../utils/Api";
import { useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import { Alert, Card, Col, Row, Spinner } from "reactstrap";
import CountrySelect2 from "../../../components/input/select/Country2";
import { getStep } from "../../../utils/Utils";


const AmlPoliticallyExposed = ({ ...props }) => {
    const [loading, setLoading] = useState(true);
    const [submitButtonLoading, setSubmitButtonLoading] = useState(false);
    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }, []);
    // window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    const [load, setLoad] = useState(0);
    if (load < 1) {
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        setLoad(2);
    }

    useEffect(() => {
        setLoading(false);
    }, []);

    const [formData, setFormData] = useState({
        relations: [{}],
    });

    const AddRelation = () => {
        const formCopy = { ...formData };
        formCopy.relations.push({});
        setFormData(formCopy);

    };

    const removeRelations = (index) => {
        const formCopy = { ...formData };
        formCopy.relations.pop(index);
        console.log(formCopy.officers)
        setFormData(formCopy);
        setValue(`relations_relationship_${index}`, null);
        setValue(`relations_name_full_${index}`, null);
        setValue(`relations_positions_${index}`, null);
        setValue(`relations_country_${index}`, null);
    };

    const {
        reset,
        register,
        handleSubmit,
        getValues,
        formState: { errors },
        setValue,
        watch,
    } = useForm();

    const onselect = (name, value) => {
        console.log(name);

        console.log(value);
        console.log(errors);
        if (name === "involve_money" && value === "n") {
            reset();
        }
    };

    const y_n_options = [
        { value: "y", label: "Yes" },
        { value: "n", label: "No" },
    ];

    const politicalOptions = [
        { "value": "hs_gov", "label": "Head of State or Head of Government" },
        { "value": "mil_gen", "label": "Military officer with a rank of general or above" },
        { "value": "exec_council", "label": "Member of the executive council of government" },
        { "value": "pres_state_co", "label": "President of a state owned company/bank" },
        { "value": "leg_member", "label": "Member of a legislature" },
        { "value": "gov_agency_head", "label": "Head of a government agency" },
        { "value": "dep_minister", "label": "Deputy minister or equivalent rank" },
        { "value": "judge_any_level", "label": "Judge (any level)" },
        { "value": "amb_attaché", "label": "Ambassador, or attaché" },
        { "value": "party_leader", "label": "Leader or president of a political party represented in a legislature" },
        { "value": "counselor_amb", "label": "Counselor of an ambassador" },
        { "value": "dom_pep", "label": "Domestic PEP (e.g., Canada or U.S.)" },
        { "value": "gov_head", "label": "Governor General, lieutenant-governor, head of government" },
        { "value": "pres_corp", "label": "President of a corporation that is wholly owned directly by the Crown or Government" },
        { "value": "senate_member", "label": "Member of the Senate or House of Commons or member of a legislature" },
        { "value": "fed_prov_agency_head", "label": "Head of a federal or provincial or state government agency" },
        { "value": "dep_minister_eq", "label": "Deputy minister of federal/provincial/state government or equivalent rank" },
        { "value": "judge_appellate", "label": "Judge of an appellate court in a province, state, Federal or Supreme Court" },
        { "value": "ambassador_attaché", "label": "Ambassador or attaché or counselor of an ambassador" },
        { "value": "party_leader_leg", "label": "Leader or a president of a political party represented in legislature" },
        { "value": "mil_gen_repeat", "label": "Military officer with a rank of general or above (duplicate)" },
        { "value": "mayor", "label": "Mayor" }
    ]



    const locationAccess = async () => {
        return new Promise((resolve, reject) => {
            const options = {
                enableHighAccuracy: true, // Request high accuracy (GPS)
                timeout: 10000, // Set a timeout of 10 seconds
                maximumAge: 0, // Ensure the result is not a cached position
            };

            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    // setValue("location", { latitude, longitude });
                    resolve({ latitude, longitude });
                },
                (err) => {
                    // Handle error
                    console.log(err);
                    resolve({ latitude: null, longitude: null });
                },
                options,
            );
        });
    };

    const onFormSubmit = async () => {
        console.log("submit");
        console.log(getValues())

        setSubmitButtonLoading(false);
        const location = await locationAccess();
        setValue("latitude", location.latitude);
        setValue("longitude", location.longitude);
        let data = {
            is_pep_hio: getValues("is_pep_hio"),
            is_pep_hio_family: getValues('is_pep_hio_family'),
            latitude: location.latitude,
            longitude: location.longitude
        }
        if (getValues('is_pep_hio') === 'y') {
            data.position_pep_hio = getValues('position_pep_hio')
            data.position_country_pep_hio = getValues('position_country_pep_hio')

        } else { }

        if (getValues('is_pep_hio_family') === 'y') {
            console.log('y')
            console.log(formData.relations)
            let family = [];
            for (let i = 0; i < formData.relations.length; i++) {
                family.push({
                    relationship: getValues(`relationship_${i}`),
                    name: getValues(`name_${i}`),
                    position: getValues(`position_${i}`),
                    position_country: getValues(`position_country_${i}`),
                });
            }
            data.family = family
        }
        try {
            await apiRequest(`/ccr/kyc/step/${await getStep('politically_exposed')}`, "POST", data).then((resp) => {
                if (resp) {
                    if (resp.code === 200) {
                        console.log(resp);
                        console.log(localStorage.getItem("at_requestor"));
                        localStorage.setItem("at_position", JSON.stringify({ step: resp.data.step }));
                        props.jump(resp.data.step);
                    } else {
                        toast.error("Something went wrong,Try again later", {
                            position: toast.POSITION.BOTTOM_RIGHT,
                        });
                        console.log("error response: ", resp.message);
                        setSubmitButtonLoading(false);
                    }
                } else {
                    setSubmitButtonLoading(false);
                }
            });
        } catch (err) {
            console.log(err);
            toast.error("Something went wrong,Try again later", {
                position: toast.POSITION.BOTTOM_RIGHT,
            });
        }

    };

    const handleFormSubmit = async (event) => {
        event.preventDefault();
        // console.log('submit');
        console.log(getValues())
        // return
        await handleSubmit(onFormSubmit)();

        if (Object.keys(errors).length) {
            toast.error('missing information', {
                position: toast.POSITION.BOTTOM_RIGHT,
            });
        }
    };

    return (
        <React.Fragment>
            <Head title="Transaction Diligence" />
            {/* <HeaderCCR></HeaderCCR> */}
            <div className="mb-2"></div>
            {loading && <Loading />}
            {!loading && (
                <Content>
                    <div className="content-page wide-md m-auto">
                        <Block className={submitButtonLoading && "disabled"}>
                            <h5>Politically Exposed Person (PEP) or Head of an International Organization (HIO)</h5>
                            <p>A Politically Exposed Person is a domestic or foreign individual who is entrusted with a prominent public function, such
                                as serving in a prescribed government office or holding a political position. A foreign PEP would be a PEP where the
                                position was held in or on behalf of a foreign country. A domestic PEP would be a PEP where the position was held in or on
                                behalf of the country in which this matter, including any transactions therefrom, resides. Refer to the table below for a list of Foreign and Domestic PEP positions.</p>
                            <p>Examples Include:</p>

                            <table className={styles.table}>
                                <thead className={styles.tableHeader}>
                                    <tr>
                                        <th colSpan='2'>Foreign PEPs</th>
                                    </tr>

                                </thead>
                                <tbody>
                                    <tr className={styles.tableRow}>
                                        <td>Head of State or Head
                                            of Government
                                        </td>

                                    </tr>
                                    <tr className={styles.tableRow}>
                                        <td>Military officer with a
                                            rank of general or
                                            above
                                        </td>

                                    </tr>
                                    <tr className={styles.tableRow}>
                                        <td>
                                            Member of the
                                            executive council of
                                            government

                                        </td>
                                    </tr>
                                    <tr className={styles.tableRow}>
                                        <td>
                                            President of a stateowned
                                            company/bank

                                        </td>

                                    </tr>
                                    <tr className={styles.tableRow}>
                                        <td>
                                            Member of a legislature
                                        </td>
                                    </tr>
                                    <tr className={styles.tableRow}>
                                        <td>
                                            Head of a government
                                            agency

                                        </td>

                                    </tr>
                                    <tr className={styles.tableRow}>
                                        <td>
                                            Deputy minister or equivalent rank
                                        </td>
                                    </tr>
                                    <tr className={styles.tableRow}>
                                        <td>
                                            Judge (any level)
                                        </td>

                                    </tr>
                                    <tr className={styles.tableRow}>
                                        <td>
                                            Ambassador, or attaché
                                        </td>
                                    </tr>
                                    <tr className={styles.tableRow}>
                                        <td>
                                            Leader or president of a
                                            political party
                                            represented in a
                                            legislature

                                        </td>

                                    </tr>
                                    <tr className={styles.tableRow}>
                                        <td>
                                            Counsellor of an ambassador
                                        </td>
                                    </tr>

                                </tbody>
                            </table>

                            <table className={styles.table}>
                                <thead className={styles.tableHeader}>
                                    <tr>
                                        <th colSpan='2'>Domestic PEP (eg. Canada or U.S.)</th>
                                    </tr>

                                </thead>
                                <tbody>
                                    <tr className={styles.tableRow}>
                                        <td>Governor General,
                                            lieutenant-governor, head
                                            of government

                                        </td>

                                    </tr>
                                    <tr className={styles.tableRow}>
                                        <td>President of a corporation
                                            that is wholly owned
                                            directly by the Crown or Government

                                        </td>

                                    </tr>
                                    <tr className={styles.tableRow}>
                                        <td>
                                            Member of the Senate or
                                            House of commons or
                                            member of a legislature


                                        </td>
                                    </tr>
                                    <tr className={styles.tableRow}>
                                        <td>
                                            Head of a federal or
                                            provincial or state government
                                            agency


                                        </td>

                                    </tr>
                                    <tr className={styles.tableRow}>
                                        <td>
                                            Deputy minister of
                                            federal/provincial/state
                                            government or equivalent
                                            rank

                                        </td>
                                    </tr>
                                    <tr className={styles.tableRow}>
                                        <td>
                                            Judge of an appellate
                                            court in a province, state,
                                            Federal or Supreme Court
                                        </td>

                                    </tr>
                                    <tr className={styles.tableRow}>
                                        <td>
                                            Ambassador or attaché or
                                            counsellor of an
                                            ambassador

                                        </td>
                                    </tr>
                                    <tr className={styles.tableRow}>
                                        <td>
                                            Leader or a president of a
                                            political party represented
                                            in legislature

                                        </td>

                                    </tr>
                                    <tr className={styles.tableRow}>
                                        <td>
                                            Military officer with a rank of
                                            general or above
                                        </td>
                                    </tr>
                                    <tr className={styles.tableRow}>
                                        <td>
                                            Mayor


                                        </td>

                                    </tr>


                                </tbody>
                            </table>
                            {/* <Alert className="alert-icon mt-5 border" color="white"> */}
                            {/* <Icon name="alert-circle" /> */}
                            <div className="mb-1">
                                Head of an International Organization (HIO) is a person who is either the head of an international organization established
                                by the governments of states or is the head of an institution established by an international organization. An international
                                organization is set up by the government of more than one country. An HIO is the primary person who leads the
                                organization; for example, the president or CEO.
                            </div>
                            {/* </Alert> */}
                            <Alert className="alert-icon mt-5 border" color="white">
                                <Icon name="alert-circle" />
                                <div className="mb-1">
                                    A family member or a close associate of a foreign or domestic PEP or an HIO is also considered politically exposed and
                                    must be identified as a family member or close associate of such an individual.

                                </div>
                            </Alert>
                            <Alert className="alert-icon mt-5 border" color="white">
                                <Icon name="alert-circle" />
                                <div className="mb-1">
                                    A family member of a PEP or HIO includes their biological or legally adoptive mother or father, biological or legally adopted child, spouse or
                                    common-law partner, biological or legally adoptive mother or father of a spouse or common-law partner, biological/legally adopted child of their
                                    mother or father.
                                    A close associate is an individual who is closely connected to a PEP or an HIO for personal or business reasons.
                                </div>
                            </Alert>
                            <form className="content clearfix" onSubmit={handleFormSubmit}>

                                <RSelect2
                                    onselect={onselect}
                                    setValue={setValue}
                                    selectedAct={watch("is_businvolve_moneyiness")}
                                    label="Are you a Politically Exposed Person (PEP) or Head of an International Organization (HIO)? "
                                    register={register}
                                    requiredMessage="This field is required"
                                    id="is_pep_hio"
                                    name="is_pep_hio"
                                    errors={errors}
                                    options={y_n_options}
                                    placeholder="Select"
                                    className="form-control-lg p-0 border-0 form-control"
                                />

                                {watch('is_pep_hio') === 'y' &&
                                    <>
                                        <p className="form-label mb-6">Please describe your position:</p>

                                        <PreviewCard className="mb-2">


                                            <Input
                                                type="text"
                                                label="Position(s) Held"
                                                id={`position_pep_hio`}
                                                name={`position_pep_hio`}
                                                className="form-control-lg form-control"
                                                required
                                                requiredMessage={{
                                                    required: "This field is required",
                                                    pattern: {
                                                        value: /^.{1,20}$/,
                                                        message: "Max 20 characters",
                                                    },
                                                }}
                                                errors={errors}
                                                register={register}
                                            />

                                            <CountrySelect2
                                                onselect={onselect}
                                                setValue={setValue}
                                                selectedCountry={watch("country")}
                                                label="Country Where Position Held"
                                                register={register}
                                                required
                                                requiredMessage="This field is required"
                                                id={`position_country_pep_hio`}
                                                name={`position_country_pep_hio`}
                                                errors={errors}
                                                placeholder="Select country"
                                                className="form-control-lg p-0 border-0 form-control"
                                            ></CountrySelect2>




                                        </PreviewCard>


                                    </>


                                }



                                <RSelect2
                                    onselect={onselect}
                                    setValue={setValue}
                                    label="Are you a family member or close associate of a PEP or HIO?"
                                    register={register}
                                    requiredMessage="This field is required"
                                    id="is_pep_hio_family"
                                    name="is_pep_hio_family"
                                    errors={errors}
                                    options={y_n_options}
                                    placeholder="Select"
                                    className="form-control-lg p-0 border-0 form-control "
                                />


                                {watch('is_pep_hio_family') === 'y' &&
                                    <>
                                        <p className="form-label ">Please describe the relationship to the PEP or HIO below:</p>
                                        {formData.relations.map((officer, index) => {
                                            return (
                                                <PreviewCard className="">

                                                    <div key={index} className="mt-6">
                                                        <div>
                                                            <h6>
                                                                {index !== 0 && <span
                                                                    value="member_1"
                                                                    onClick={() => removeRelations(index)}
                                                                    className="btn btn-icon delete-button"
                                                                >
                                                                    <em className="ni ni-cross"></em>
                                                                </span>}
                                                                Relation {index + 1}
                                                            </h6>
                                                            <Input
                                                                type="text"
                                                                label="Relationship"
                                                                id={`relationship_${index}`}
                                                                name={`relationship_${index}`}
                                                                className="form-control-lg form-control"
                                                                required
                                                                requiredMessage={{
                                                                    required: "This field is required",
                                                                    pattern: {
                                                                        value: /^.{1,20}$/,
                                                                        message: "Max 20 characters",
                                                                    },
                                                                }}
                                                                errors={errors}
                                                                register={register}
                                                            />
                                                            <Input
                                                                type="text"
                                                                label="Full Name of PEP or HIO"
                                                                id={`name_${index}`}
                                                                name={`name_${index}`}
                                                                className="form-control-lg form-control"
                                                                required
                                                                requiredMessage={{
                                                                    required: "This field is required",
                                                                    pattern: {
                                                                        value: /^.{1,20}$/,
                                                                        message: "Max 20 characters",
                                                                    },
                                                                }}
                                                                errors={errors}
                                                                register={register}
                                                            />
                                                            <Input
                                                                type="text"
                                                                label="Position(s) Held"
                                                                id={`position_${index}`}
                                                                name={`position_${index}`}
                                                                className="form-control-lg form-control"
                                                                required
                                                                requiredMessage={{
                                                                    required: "This field is required",
                                                                    pattern: {
                                                                        value: /^.{1,20}$/,
                                                                        message: "Max 20 characters",
                                                                    },
                                                                }}
                                                                errors={errors}
                                                                register={register}
                                                            />

                                                            <CountrySelect2
                                                                onselect={onselect}
                                                                setValue={setValue}
                                                                selectedCountry={watch("country")}
                                                                label="Country Where Position Held"
                                                                register={register}
                                                                required
                                                                requiredMessage="This field is required"
                                                                id={`position_country_${index}`}
                                                                name={`position_country_${index}`}
                                                                errors={errors}
                                                                placeholder="Select country"
                                                                className="form-control-lg p-0 border-0 form-control"
                                                            ></CountrySelect2>


                                                        </div>
                                                    </div>
                                                </PreviewCard>
                                            );
                                        })}
                                        <Button
                                            color="primary"
                                            size="block"
                                            className="mt-3"
                                            outline=""
                                            type="button"
                                            onClick={AddRelation}
                                        >
                                            + Add Another relation
                                        </Button>
                                    </>


                                }






                                <div className="mt-3 nk-kycfm-note mb-5">
                                    <em className=" icon ni ni-info-fill"></em>
                                    <p>You cannot edit your details once submitted.</p>
                                </div>

                                <div className="bg-primary" style={{ position: "fixed", bottom: "0px" }}>
                                    <div className="bg-white col-12" style={{ position: "fixed", bottom: "0px", right: "0px" }}>
                                        <div style={{ margin: "10px 5px 10px 0px", float: "right" }} className="p-1">
                                            {" "}
                                            <Button color="primary" size="" className={submitButtonLoading && "disabled"} outline="">
                                                {submitButtonLoading && <Spinner size="sm" />} Continue
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </Block>
                    </div>
                    {/* <ToastContainer /> */}
                </Content>
            )}
        </React.Fragment>
    );
};

export default AmlPoliticallyExposed;


